import { useEffect, type ReactElement } from 'react'
import { WarningCircle, Prohibit } from '@phosphor-icons/react'
import { StationFactRow } from '../../components/stationPage/StationFactRow'
import factServiceGood from '../../components/stationPage/assets/fact-service-good.svg'

/**
 * Private QA fixture: the three live states of the Overview "Service"
 * fact (TASK-699). Good service uses the designer-exported icon
 * (8688:34617); the disrupted states use the agreed minimal
 * no-design-yet set (Phosphor stand-ins + status tones) until Figma
 * variants land.
 *
 * URL contract: /__visual/station-service-states
 * Dev/QA only — excluded from robots.txt (`Disallow: /__visual/`).
 */
export function StationServiceStatesVisualFixture(): ReactElement {
  useEffect(() => {
    const html = document.documentElement
    html.classList.add('visual-fixture-active')
    return () => {
      html.classList.remove('visual-fixture-active')
    }
  }, [])

  return (
    <div style={{ background: '#fff', minHeight: '100vh', padding: '24px 32px', maxWidth: 520 }}>
      <StationFactRow
        icon={<img src={factServiceGood} alt="" width={48} height={48} />}
        label="Service"
        value="Good service"
        tone="good"
      />
      <StationFactRow
        icon={<WarningCircle size={40} weight="bold" color="#8a5a00" />}
        label="Service"
        value="Minor disruption"
        tone="advisory"
      />
      <StationFactRow
        icon={<Prohibit size={40} weight="bold" color="#b71c1c" />}
        label="Service"
        value="Station closed"
        tone="closure"
      />
    </div>
  )
}
